import React from 'react';
import './IsmsAnnouncement.css'; 
import { useNavigate } from 'react-router-dom';

const IsmsAnnouncement: React.FC = () => {
    const navigate = useNavigate();
    const handleReturn = () => {
        navigate('/');
    };

    return (
        <div className="isms-announcement-page">
            <button className="return-button" onClick={handleReturn}>
              ←
            </button>
            <div className="announcement-header">
                <h1>ISO/IEC 27001（ISMS）認証取得のお知らせ</h1>
                <img 
                    src="/images/isms-logo.jpg" 
                    alt="ISO/IEC 27001 認証マーク" 
                    className="isms-logo"
                />
            </div>
            <div className="announcement-content">
                <p>当社は、2025年12月12日、情報セキュリティマネジメントシステム（ISMS）の国際規格である「ISO/IEC 27001:2022」の認証を取得いたしました。</p>
                <p>この度の認証取得により、お客様により一層安心してサービスをご利用いただける体制を整えてまいります。</p>
            </div>
            <div className="announcement-section">
                <h2>ISO/IEC 27001（ISMS）とは</h2>
                <p>ISO/IEC 27001は、情報セキュリティマネジメントシステム（ISMS：Information Security Management System）に関する国際規格です。</p>
                <p>組織が保有する情報資産を、機密性・完全性・可用性の観点から適切に管理し、継続的に改善するための仕組みを定めています。</p>
            </div>
            <div className="announcement-section">
                <h2>認証概要</h2>
                <table className="certification-table">
                    <tbody>
                        <tr>
                            <th>認証規格</th>
                            <td>ISO/IEC 27001:2022</td>
                        </tr>
                        <tr>
                            <th>認証機関</th>
                            <td>日本品質保証機構（JQA）</td>
                        </tr>
                        <tr>
                            <th>登録範囲</th>
                            <td>コンピュータソフトウェアの開発および保守</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="announcement-section">
                <h2>今後の取り組み</h2>
                <p>当社は、本認証の取得を機に、より一層の情報セキュリティ体制の強化に努め、お客様の大切な情報を守りながら、高品質なサービスの提供に邁進してまいります。</p>
                <p>今後ともご愛顧賜りますよう、よろしくお願い申し上げます。</p>
            </div>
        </div>
    );
};

export default IsmsAnnouncement;
